import { render, staticRenderFns } from "./LayoutCoupon.vue?vue&type=template&id=a6a383ba&"
import script from "./LayoutCoupon.vue?vue&type=script&lang=js&"
export * from "./LayoutCoupon.vue?vue&type=script&lang=js&"
import style0 from "./LayoutCoupon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports